<mat-expansion-panel class="" (opened)="panelOpened(showSelected)" (closed)="panelClosed(showSelected)">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title class="sx-filter__term__title" style="text-align: left;
      flex-grow: 1;
      line-height: 0;">
      <span class="sx-filter__term-header__title">{{filter.label}}</span>
      <span class="sx-filter__term-header__subtitle" *ngIf="showSelected">{{_label}}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>
            <div class="sx-value-range-filter__panel" (click)="$event.stopPropagation()">
                <div class="sx-value-range-filter__section">
                  <div class="sx-value-range-filter__input">
                    <mat-form-field>
                      <input matInput type="text" placeholder="{{'core.rangefilter.from'| translate }}" [(ngModel)]="fromValue" (keypress)="onKeyPress($event)" (blur)="restrictMinValue($event, fromValue, min, max)">
                    </mat-form-field>
                  </div>
                  
                  <div class="sx-value-range-filter__input">
                    <mat-form-field>
                      <input matInput type="text" placeholder="{{'core.rangefilter.to'| translate}}" [(ngModel)]="toValue" (keypress)="onKeyPress($event)" (blur)="restrictMaxValue($event, toValue, min, max)">
                    </mat-form-field>
                  </div>
                </div>
              </div>
</mat-expansion-panel>